import React ,{useState , useRef} from "react";
import TableRowsPly from "./TableRowsPly";
function AddDeleteTableRowsPly({  data , add , edit , ply, del, IsDisabled}){

    const [rowsData, setRowsData] = useState([]);
  
    const deleteTableRows = (index)=>{
        const rows = [...rowsData];
        rows.splice(index, 1);
        setRowsData(rows);
    }
 
    return(
        <div className="table-responsive">
                <table className="" style={{"padding": "0" , "marginBottom" : "10px"}}>
                    <thead>
                      <tr>
                      <th>Ply Discription</th>
                      &nbsp;
                            <th>Rate</th>  
                            <th>
                              {!IsDisabled && (
                                <button type="button" className="btn btn-outline-success" onClick={add}>+</button>
                              )}
                            </th>    
                      </tr>
                    </thead>
                    <tbody>
                   <TableRowsPly 
                     rowsData={data}   
                     add={add} 
                     ply={ply} 
                     edit={edit} 
                     del={del}
                     IsDisabled={IsDisabled}
                   />
                   </tbody> 
                </table>
              
        </div>
    )
}
export default AddDeleteTableRowsPly